import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, WrenchIcon, HeadphonesIcon, ShieldIcon } from 'lucide-react';
const HomePage = () => {
  return <div className="w-full" data-id="element-233">
      {/* Hero Section */}
      <section className="relative bg-[#1A2B4C] text-white" data-id="element-234">
        <div className="absolute inset-0 bg-black opacity-50" data-id="element-235"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')",
        backgroundBlendMode: 'overlay',
        backgroundColor: 'rgba(26, 43, 76, 0.7)'
      }} data-id="element-236"></div>
        <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-237">
          <div className="max-w-2xl" data-id="element-238">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-239">
              Fast, Reliable Appliance Repairs Across the UK
            </h1>
            <p className="text-xl mb-8" data-id="element-240">
              From washing machines to boilers, Elevatefix is here to keep your
              home running smoothly. Trusted engineers, fixed-price service
              plans, and UK-based support – all in one place.
            </p>
            <Link to="/service-coverage" className="inline-block bg-[#F48C06] hover:bg-[#e07f00] text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-241">
              View Our Services
            </Link>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section className="py-16 bg-white" data-id="element-242">
        <div className="container mx-auto px-4" data-id="element-243">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B4C]" data-id="element-244">
            Why Choose Elevatefix?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-245">
            <div className="bg-[#F5F7FA] p-6 rounded-lg shadow-sm text-center" data-id="element-246">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1FC5A8] text-white rounded-full mb-4" data-id="element-247">
                <WrenchIcon size={32} data-id="element-248" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A2B4C]" data-id="element-249">
                Professional Repairs
              </h3>
              <p className="text-gray-600" data-id="element-250">
                Expert repairs for all major home appliances
              </p>
            </div>
            <div className="bg-[#F5F7FA] p-6 rounded-lg shadow-sm text-center" data-id="element-251">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1FC5A8] text-white rounded-full mb-4" data-id="element-252">
                <CheckIcon size={32} data-id="element-253" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A2B4C]" data-id="element-254">
                Transparent Pricing
              </h3>
              <p className="text-gray-600" data-id="element-255">
                Fixed-price service plans with no hidden fees
              </p>
            </div>
            <div className="bg-[#F5F7FA] p-6 rounded-lg shadow-sm text-center" data-id="element-256">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1FC5A8] text-white rounded-full mb-4" data-id="element-257">
                <ShieldIcon size={32} data-id="element-258" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A2B4C]" data-id="element-259">
                Peace of Mind
              </h3>
              <p className="text-gray-600" data-id="element-260">
                Trusted engineers with years of experience
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonial Section */}
      <section className="py-16 bg-[#F5F7FA]" data-id="element-261">
        <div className="container mx-auto px-4" data-id="element-262">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B4C]" data-id="element-263">
            What Our Customers Say
          </h2>
          <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm" data-id="element-264">
            <div className="text-[#1FC5A8] text-4xl font-serif mb-4" data-id="element-265">"</div>
            <p className="text-lg mb-6 text-gray-700" data-id="element-266">
              Elevatefix repaired my washing machine within 24 hours. The
              engineer was polite, professional, and explained everything
              clearly. Fantastic service!
            </p>
            <div className="font-bold text-[#1A2B4C]" data-id="element-267">- Sarah, Birmingham</div>
          </div>
        </div>
      </section>
      {/* Payment Plans Section */}
      <section className="py-16 bg-white" data-id="element-268">
        <div className="container mx-auto px-4" data-id="element-269">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B4C]" data-id="element-270">
            Our Service Plans
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-271">
            <div className="bg-[#F5F7FA] rounded-lg shadow-sm overflow-hidden" data-id="element-272">
              <div className="p-6" data-id="element-273">
                <div className="flex justify-center mb-6" data-id="element-274">
                  <img src="https://images.unsplash.com/photo-1610557892470-55d9e80c0bce?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80" alt="Washing Machine" className="w-20 h-20 object-cover rounded-full" data-id="element-275" />
                </div>
                <h3 className="text-xl font-bold mb-2 text-center text-[#1A2B4C]" data-id="element-276">
                  £99 One-Year Service Plan
                </h3>
                <h4 className="text-center text-[#1FC5A8] font-medium mb-4" data-id="element-277">
                  1 Appliance
                </h4>
                <p className="text-center mb-6 text-gray-600" data-id="element-278">
                  "Reliable Cover for your Appliance"
                  <br data-id="element-279" />
                  12 months' professional care. Unlimited repairs, priority
                  support, and complete peace of mind.
                </p>
                <div className="text-center" data-id="element-280">
                  <a href="https://buy.stripe.com/14AdRagiY2VB66ifNw04801" target="_blank" rel="noopener noreferrer" className="bg-[#F48C06] hover:bg-[#e07f00] text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-281">
                    Choose This Plan
                  </a>
                </div>
              </div>
            </div>
            <div className="bg-[#F5F7FA] rounded-lg shadow-sm overflow-hidden" data-id="element-282">
              <div className="p-6" data-id="element-283">
                <div className="flex justify-center mb-6" data-id="element-284">
                  <img src="https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80" alt="TV and Set-Top Box" className="w-20 h-20 object-cover rounded-full" data-id="element-285" />
                </div>
                <h3 className="text-xl font-bold mb-2 text-center text-[#1A2B4C]" data-id="element-286">
                  £120 One-Year Service Plan
                </h3>
                <h4 className="text-center text-[#1FC5A8] font-medium mb-4" data-id="element-287">
                  TV + Set-Top Box
                </h4>
                <p className="text-center mb-6 text-gray-600" data-id="element-288">
                  "Keep Your Entertainment Running Smoothly"
                  <br data-id="element-289" />
                  Unlimited repairs and rapid-response service for your TV and
                  set-top box.
                </p>
                <div className="text-center" data-id="element-290">
                  <a href="https://buy.stripe.com/28EfZi6IoeEjfGSeJs04800" target="_blank" rel="noopener noreferrer" className="bg-[#F48C06] hover:bg-[#e07f00] text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-291">
                    Choose This Plan
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#1A2B4C] text-white" data-id="element-292">
        <div className="container mx-auto px-4 text-center" data-id="element-293">
          <h2 className="text-3xl font-bold mb-6" data-id="element-294">Ready to get started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-295">
            Contact our team today for more information or to book an engineer.
          </p>
          <Link to="/contact" className="inline-block bg-[#1FC5A8] hover:bg-[#19b094] text-white font-bold py-3 px-8 rounded-lg transition-colors" data-id="element-296">
            Contact Us
          </Link>
        </div>
      </section>
    </div>;
};
export default HomePage;